import { formatDateString } from '~libs/dayjs';

import { Column } from '~components/table-view';

export const commonColumns: Column[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'start_time',
    header: 'Time',
    type: 'text',
  },
];

export const notLoggedInColumns: Column[] = [
  {
    id: 'full_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'last_login',
    header: 'Last Login',
    type: 'text',
    deriveValue: (row) => (row.last_login ? formatDateString(row.last_login) : 'Never Logged In'),
  },
];
